import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import ProjectHeader from '../ProjectHeader';
import TaskSwimLanes from './TaskSwimLanes';
import WaitSpinner from '../../../components/WaitSpinner';
import './TasksContainerTasks.scss';
import { task_summary_root } from '../../../dao/collections/TasksAssignedCollection';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import SelectUserComboBox from '../../../components/SelectUserComboBox';
import userService from '../../../services/userService';
import LoadingDots from '../../../components/LoadingDots';

export const userDescriptor = { user: { companies: {}, role: {}, directories: {}, markets: {}, market_vendor_users: { market: {} }, vendor_markets: {} } };

export class TasksContainerTasks extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      allProjects: false,
      displayHeight: 0,
      currentlyViewing: this.props.selectedTaskView ? this.props.selectedTaskView : '',
      inProgress: false,
      loadingUsers: false,
      selectedUser: this.props.currentUser && this.props.currentCompany && this.props.currentUser.primary_company_id === this.props.currentCompany.id ? this.props.currentUser : null,
      usersList: null,
    };

    this.getNextPage = this.getNextPage.bind(this);
  }

  handleTaskRetrieveNotStarted(myTasksNotStarted, action, acData, fetchedData) {
    this.setState({ myTasksNotStarted });
  }

  handleTaskRetrieveInProgress(myTasksInProgress, action, acData, fetchedData) {
    this.setState({ myTasksInProgress });
  }

  handleTaskRetrieveUnderReview(myTasksUnderReview, action, acData, fetchedData) {
    this.setState({ myTasksUnderReview });
  }

  handleTaskRetrieveCompleted(myTasksCompleted, action, acData, fetchedData) {
    this.setState({ myTasksCompleted });
  }

  componentDidMount() {
    const perPage = Math.floor(((window.innerHeight - 194) / 131 + .5));
    this.myTasksNotStartedAssigned = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveNotStarted, 'TasksAssigned', this.props.currentUser.id, null, ['not_started'], true, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null);
    this.myTasksInProgressAssigned = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveInProgress, 'TasksAssigned', this.props.currentUser.id, null, ['in_progress'], true, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null);
    this.myTasksUnderReviewAssigned = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveUnderReview, 'TasksAssigned', this.props.currentUser.id, null, ['under_review'], true, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null);
    // this.myTasksNotStartedUnassigned = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveNotStarted, 'TasksAssigned', this.props.currentUser.id, null, ["not_started"], false, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null)
    // this.myTasksInProgressUnassigned = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveInProgress, 'TasksAssigned', this.props.currentUser.id, null, ["in_progress"], false, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null)
    // this.myTasksUnderReviewUnassigned = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveUnderReview, 'TasksAssigned', this.props.currentUser.id, null, ["under_review"], false, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null)
    this.myTasksCompleted = new CollectionDataSource('TasksAssignedCollection', 'Task', task_summary_root, this.handleTaskRetrieveCompleted, 'TasksAssigned', this.props.currentUser.id, null, ['completed'], true, 1, perPage, null, this.props.userProject ? this.props.userProject.id : null);
    if (this.props.allProjects) {
      this.switchAllOrActiveTasks('Active Tasks', null);
      this.setState({ allProjects: true, currentlyViewing: 'activeTasks' });
    }
    else if (this.props.userProject) {
      this.switchAllOrActiveTasks('All Tasks', this.props.userProject.id);
    }

    if(!this.state.usersList){
      this.getUsersList();
    }
  }

  componentWillUnmount() {
    const filter = {};
    filter.user = null;
    this.myTasksNotStartedAssigned.filter = filter;
    this.myTasksInProgressAssigned.filter = filter;
    this.myTasksUnderReviewAssigned.filter = filter;
    this.myTasksCompleted.filter = filter;
    if (this.myTasksNotStartedAssigned) {
      this.myTasksNotStartedAssigned.release();
      this.myTasksNotStartedAssigned = null;
    }
    if (this.myTasksInProgressAssigned) {
      this.myTasksInProgressAssigned.release();
      this.myTasksInProgressAssigned = null;
    }
    if (this.myTasksUnderReviewAssigned) {
      this.myTasksUnderReviewAssigned.release();
      this.myTasksUnderReviewAssigned = null;
    }
    if (this.myTasksNotStartedUnassigned) {
      this.myTasksNotStartedUnassigned.release();
      this.myTasksNotStartedUnassigned = null;
    }
    if (this.myTasksInProgressUnassigned) {
      this.myTasksInProgressUnassigned.release();
      this.myTasksInProgressUnassigned = null;
    }
    if (this.myTasksUnderReviewUnassigned) {
      this.myTasksUnderReviewUnassigned.release();
      this.myTasksUnderReviewUnassigned = null;
    }
    if (this.myTasksCompletedmyTasksCompleted) {
      this.myTasksCompletedmyTasksCompleted.release();
      this.myTasksCompletedmyTasksCompleted = null;
    }
  }

  componentDidUpdate(prevProps) {
    if ((!prevProps.userProject && this.props.userProject) ||
      (prevProps.userProject && !this.props.userProject) ||
      (prevProps.userProject && this.props.userProject && prevProps.userProject.id != this.props.userProject.id) ||
      prevProps.refreshView != this.props.refreshView) {
      this.reloadTasks(this.props.userProject ? this.props.userProject.id : null, this.state.currentlyViewing == 'activeTasks');
    }
  }

  handleExpansion(height) {
    this.setState({ displayHeight: height + (height == 0 ? 0 : 20) });
    if (this.props.handleMapExpansion) {
      this.props.handleMapExpansion(height > 0);
    }
  }

  getUsersList(){
    this.setState({ loadingUsers: true });
    const tempUsers = []; 
    userService.getUsers().then((response)=>{
      response.data.map((data)=>{
        tempUsers.push(data.attributes);
      });
      this.setState({ usersList: tempUsers, loadingUsers: false });
    });
  }

  reloadTasks(project_id, onlyLoadAssigned, actionCable) {
    // const collectionSuffix = onlyLoadAssigned ? 'Assigned' : 'Unassigned'

    const collectionSuffix = 'Assigned';

    const notStartedCollectionName = 'myTasksNotStarted' + collectionSuffix;
    const inProgressCollectionName = 'myTasksInProgress' + collectionSuffix;
    const underReviewCollectionName = 'myTasksUnderReview' + collectionSuffix;

    this[notStartedCollectionName].project_id = project_id;
    this[inProgressCollectionName].project_id = project_id;
    this[underReviewCollectionName].project_id = project_id;

    if (!onlyLoadAssigned) {
      this.myTasksCompleted.project_id = project_id;
    }

    this[notStartedCollectionName].current();
    this[inProgressCollectionName].current();
    this[underReviewCollectionName].current();
    if (!onlyLoadAssigned) {
      this.myTasksCompleted.current();
    }
  }
  
  isUserAdminOrAbove(){
    const { currentUser } = this.props;
    const currentUserRole = currentUser.role_name && currentUser.role_name.toLowerCase();
    if(currentUserRole === 'admin' || currentUserRole === 'super_user'){
      return true;
    }
    else{
      return false;
    }
  }

  switchAllOrActiveTasks(switchTo, project_id, actionCable) {
    const filter = {};
    filter.user = this.state.selectedUser;
    if (!switchTo) {
      switchTo = this.state.currentlyViewing;
    }
    if ((switchTo == 'All Tasks' || switchTo == 'allProjectsTasks') && project_id) {
      this.setState({ currentlyViewing: 'allProjectsTasks', inProgress: true, project_id });
      this.handleFilterChange(filter, 'allProjectsTasks');
      this.reloadTasks(project_id, false, actionCable);
    } else if (switchTo == 'All Tasks' || switchTo == 'allProjectsTasks') {
      this.setState({ currentlyViewing: 'allProjectsTasks', inProgress: true, project_id });
      this.handleFilterChange(filter, 'allProjectsTasks');
      this.reloadTasks(null, false, actionCable);
    } else if (switchTo == 'Active Tasks' || switchTo == 'activeTasks') {
      this.setState({ currentlyViewing: 'activeTasks', project_id });
      this.handleFilterChange(filter, 'activeTasks');
      this.reloadTasks(null, true, actionCable);
    }
  }

  handleTaskViewSwitch(e) {
    e.preventDefault();
    this.switchAllOrActiveTasks(e.target.name);
    return;
  }

  getNextPage(collectionName) {
    if (collectionName != 'myTasksCompleted') {
      const collectionNameSuffix = this.state.currentlyViewing == 'allProjectsTasks' ? 'Unassigned' : 'Assigned';
      collectionName += collectionNameSuffix;
    }

    return this[collectionName].next();
  }

  handleFilterChange(filter,viewState){
    if(filter){
      this.myTasksNotStartedAssigned.filter = filter;
      this.myTasksNotStartedAssigned.current();
      this.myTasksInProgressAssigned.filter = filter;
      this.myTasksInProgressAssigned.current();
      this.myTasksUnderReviewAssigned.filter = filter;
      this.myTasksUnderReviewAssigned.current();
      if(viewState == 'allProjectsTasks'){
        this.myTasksCompleted.filter = filter;
        this.myTasksCompleted.current();
      }
      else{
        filter.user = null;
        this.myTasksCompleted.filter = filter;
        this.setState({ myTasksCompleted: null });
      }
    }
  }

  handleUserSelection(type, optionSelected) {
    // Read the new selection directly. this.state.selectedUser is still the PREVIOUS
    // value at this point (setState is async), so filtering on it applied the wrong user
    // and clearing the selection (type === -1) kept sending the old one.
    const selectedUser = optionSelected.type === -1 ? null : optionSelected.user;
    this.setState({ selectedUser });

    const filter = {};
    filter.user = selectedUser;
    // Pass the current view. Without it handleFilterChange sees viewState === undefined,
    // takes its else branch and sets myTasksCompleted to null WITHOUT refetching. In the
    // project view (currentlyViewing === 'allProjectsTasks') render() requires
    // myTasksCompleted, so the WaitSpinner never clears.
    this.handleFilterChange(filter, this.state.currentlyViewing);
  }

  render() {
    let { selectedUser, loadingUsers } = this.state;

    const pageHeader =
    <ProjectHeader
      projectId={this.props.userProject && this.props.userProject.id}
      allProjects={this.props.allProjects}
      build={this.build}
      type='builds-page'
      handleExpansion={this.handleExpansion}
      mapExpanded={this.props.mapExpanded}
      myProjects={this.props.projects}
      inProjectsTab={false}
      isLeftDividerHide={true}
    />;

    let subHeader = this.isUserAdminOrAbove() ? (
      <div className='filter-wrapper'>  
        <div className={'filter-container filter-container__users'}>
          <div className='filter-selector-label'>
            {'USER'}
          </div>
          <div className='filter-selector-container'>
            <SelectUserComboBox 
              id={'userPicker'} 
              width={260} 
              height={26} 
              top={16}
              hasBorder={false} 
              multiSelect={false}
              handleSelection={this.handleUserSelection} 
              currentSelectedUser={selectedUser}
              users={this.state.usersList} 
              small={true}
            />
            {loadingUsers && <LoadingDots />}
          </div>
        </div>
      </div>
    ) : null;

    let onlyLoadAssigned = this.state.currentlyViewing == 'activeTasks';
    let waitSpinner = null;
    if (!this.state.myTasksInProgress || !this.state.myTasksNotStarted || !this.state.myTasksUnderReview || (!this.state.myTasksCompleted && !onlyLoadAssigned)) {
      waitSpinner = <WaitSpinner />;
    }

    let taskFilterButtons;
    if (this.state.allProjects) {
      taskFilterButtons =
      <div>
        <button
          className={`tasks-view-button ${this.state.currentlyViewing ==
            'activeTasks' && 'selected'}`}
          name="Active Tasks"
          onClick={this.handleTaskViewSwitch}
        >
          Active Tasks
        </button>
        <button
          className={`tasks-view-button ${this.state.currentlyViewing ==
            'allProjectsTasks' && 'selected'}`}
          name="All Tasks"
          onClick={this.handleTaskViewSwitch}
        >
          All Tasks
        </button>
      </div>;
    }

    let height = 60;
    let alternateHeight = 40;

    if(this.props.userProject && this.props.userProject.id){
      height = 185;
      alternateHeight = 165;
    }
    
    return (
      <div className="project-tasks" >
        {waitSpinner}
        {pageHeader}
        <div className="project-tasks-container" style={{ top: this.isUserAdminOrAbove() ? height : alternateHeight + this.state.displayHeight }}>
        {subHeader}
          <div className={'project-tasks-detail my-tasks'}>
            <div className="project-tasks-view-toggle">
              {taskFilterButtons}
            </div>
            <TaskSwimLanes 
              getNextPage={this.getNextPage}
              mapExpanded={this.props.mapExpanded}
              myTasksInProgress={this.state.myTasksInProgress} 
              myTasksNotStarted={this.state.myTasksNotStarted}
              myTasksUnderReview={this.state.myTasksUnderReview}
              myTasksCompleted={this.state.myTasksCompleted}
              inProjectsTab={false}
              selectedTaskIds={new Set()}
              selectedProject={this.props.userProject}
              permissions={this.props.permissions}
            />
            </div>
          </div>
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(TasksContainerTasks);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/TasksContainerTasks/index.js